import { render, staticRenderFns } from "./fromLocal.vue?vue&type=template&id=15fd6ba7&scoped=true&"
import script from "./fromLocal.vue?vue&type=script&lang=js&"
export * from "./fromLocal.vue?vue&type=script&lang=js&"
import style0 from "./fromLocal.vue?vue&type=style&index=0&id=15fd6ba7&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fd6ba7",
  null
  
)

export default component.exports